import { styled } from '@creditas/stylitas'

const StackTrace = styled.pre`
  margin-left: 24px;
  margin-top: 24px;
  color: #a00;
  border-left: 4px solid #cbb;
  padding: 4px 12px;
`

export { StackTrace }
